import api from "../utils/api";
import { PLAN_DETAILS } from "../constants/routes";
import localStorageService from "./localStorageService";

export type PlanSportRow = {
  sport_code?: string;
  sportCode?: string;
  sport?: string;
  status?: string;
  cost?: number;
  price?: number;
  amount?: number;
  sport_cost?: number;
  currency?: string;
  active_addons?: PlanAddonRow[];
  subscription_end?: string;
};

export type PlanAddonSeasonRow = {
  season?: string;
  total_cost?: number;
  totalCost?: number;
  cost?: number;
  amount?: number;
  currency?: string;
};

export type PlanAddonRow = {
  id?: number;
  addon?: string;
  addon_name?: string;
  addonName?: string;
  name?: string;
  addon_type_id?: number;
  addonTypeId?: number;
  sport_code?: string;
  sportCode?: string;
  status?: string;
  active?: boolean;
  selected_seasons?: string[];
  selectedSeasons?: string[];
  seasons?: PlanAddonSeasonRow[] | Record<string, any>;
  cost_per_season?: number;
  costPerSeason?: number;
  total_cost?: number;
  totalCost?: number;
  cost?: number;
  amount?: number;
  currency?: string;
};

export type PlanDetailsResponse = {
  sports?: PlanSportRow[];
  addons?: PlanAddonRow[];
  data?: {
    sports?: PlanSportRow[];
    addons?: PlanAddonRow[];
  };
  [key: string]: any;
};

class PlanDetailsService {
  public getPlanDetails = async (username?: string) => {
    try {
      const userInfo = localStorageService.getUserInfo();
      const token = userInfo?.token;

      const headers: Record<string, string> = {
        Accept: "application/json",
      };
      if (token) headers.Authorization = `Bearer ${token}`;

      const qs = username ? `?username=${encodeURIComponent(username)}` : "";
      const candidates = [
        `${PLAN_DETAILS}${qs}`,
        `${PLAN_DETAILS.replace(/\/$/, "")}/${qs.startsWith("?") ? qs.slice(1) : qs}`,
        `${PLAN_DETAILS.replace("plan-details", "plan_details")}${qs}`,
        `${PLAN_DETAILS.replace("plan-details", "plan_details").replace(/\/$/, "")}/${qs.startsWith("?") ? qs.slice(1) : qs}`,
      ];

      let lastError: any = null;
      for (const url of candidates) {
        try {
          const response = await api.get<PlanDetailsResponse>(url, { headers });
          return response;
        } catch (err: any) {
          // If it's not a 404, return immediately; otherwise try fallback routes.
          const status = err?.response?.status;
          if (status && status !== 404) return err?.response || err;
          lastError = err;
        }
      }

      return lastError?.response || lastError;
    } catch (error: any) {
      return error?.response || error;
    }
  };
}

const planDetailsService = new PlanDetailsService();
export default planDetailsService;
